import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { findEntityById } from "@qgiv/core-js";
import ProductDetails from "./ProductDetails";
import { selectAllRegistration } from "../../../../redux/slices/registrationSlice";
import { selectAllProductModal } from "../../../../redux/slices/productModalSlice";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";

const ConnectedProductDetails = ({ productId }) => {
    const registration = useSelector(selectAllRegistration);
    const { storeCart = [] } = registration;
    const { currentStoreCartItemIndex = -1 } = useSelector(
        selectAllProductModal,
    );
    const products = useSelector(selectAllProducts);

    const settings = { registration, products };

    // eslint-disable-next-line no-shadow
    const productCategory = products.find(({ products }) =>
        products.find(findEntityById(productId)),
    );
    const product = productCategory.products.find(findEntityById(productId));
    const {
        description = "",
        hasAttributes = false,
        images = [],
        fields = {},
    } = product;

    const savedStoreCartValues =
        currentStoreCartItemIndex !== -1 && storeCart[currentStoreCartItemIndex]
            ? storeCart[currentStoreCartItemIndex]
            : {};

    // Bool if there are more than 1 image
    const displayImg = images.length > 0;

    // Should pass a length: if 0 no image shows, if one display CardImage, if > 1 show ImageCarrousel
    const displayImageCarrousel = !!(displayImg && images.length > 1);

    // Boolean only if attributes are present for item
    const displayAttribute = !!(
        hasAttributes && Object.keys(fields).length > 0
    );
    // Boolean only if details are present
    const displayDescription = description.length > 0;

    const productDetailsProps = {
        displayAttribute,
        displayDescription,
        displayImg,
        displayImageCarrousel,
        hasAttributes,
        product,
        savedStoreCartValues,
        settings,
        storeCart,
    };
    return <ProductDetails {...productDetailsProps} />;
};

ConnectedProductDetails.propTypes = {
    productId: PropTypes.PropTypes.number.isRequired,
};

export default ConnectedProductDetails;
